export default __webpack_public_path__ + "static/testimonials1-0d2f811df4c45f806b5fe941a2ed15c8.png";